import SectionHeading from '@/pages/home/components/SectionHeading';
import { guideSteps } from '@/mocks/content';

export default function Guide() {
  return (
    <section id="guide" className="py-12 md:py-16 scroll-mt-20 bg-background-100/70">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="观看指南"
          title="观看指南：四步找到你想看的内容"
          desc="第一次打开不知道该从哪儿开始？照着下面的顺序走一遍，基本就能形成自己的浏览习惯。整个过程不需要注册，也不会跳转到站外。"
          align="center"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {guideSteps.map((step, index) => (
            <article
              key={step.step}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1 dv-reveal"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl">
                  <i className={step.icon} />
                </span>
                <span className="font-heading text-3xl font-black text-background-300">{step.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              {index < guideSteps.length - 1 ? (
                <span className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-400 text-sm">
                  <i className="ri-arrow-right-s-line" />
                </span>
              ) : null}
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-lg border border-accent-300 bg-accent-50 px-5 py-4 md:px-7 md:py-5">
          <div>
            <p className="font-heading text-base md:text-lg font-bold text-foreground-950">
              准备好了吗？从今天的热门推荐开始
            </p>
            <p className="mt-1 text-xs md:text-sm text-foreground-600">
              12,800+ 个作品已经按类型整理好，挑一个顺眼的点开就行。
            </p>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg" />
            去看热门推荐
          </a>
        </div>
      </div>
    </section>
  );
}